/* Maison Alméa — sélecteur de packs (fiche produit). 30/09 perf : sorti de sections/almea-com-packs.liquid ; async, attend son bloc. */
(function(CS){
  var __UID = CS ? CS.getAttribute('data-uid') : '';
  (function almBoot(){
    if (document.readyState === 'loading' && !document.getElementById('almpk-' + __UID) && !(!__UID && document.querySelector('[data-almpk]'))) { setTimeout(almBoot, 20); return; }

(function () {
  var wrap = document.getElementById('almpk-' + __UID) || (!__UID ? document.querySelector('[data-almpk]') : null); /* 30/09 16h30 : lancé aussi SANS uid, avant le 1er affichage (voir z-pageproduirgong) */
  if (!wrap || wrap.getAttribute('data-almpk-init') === '1') return;
  wrap.setAttribute('data-almpk-init', '1');
  var step = wrap.querySelector('[data-pk-step]'), info = wrap.querySelector('[data-pk-info]');
  var OFF2 = parseFloat(wrap.getAttribute('data-off2')) || 0;
  var OFF3 = parseFloat(wrap.getAttribute('data-off3')) || 0;
  var MAXQ = 23; /* 07/10 20h15 : jusqu'à 23 (tarif pro dès 24) */
  var qtyEl = null, priceEl = null, row = null, box = null, base = null, prObs = null, boxObs = null;
  var stickyEl = null, stickyInfo = null, stObs = null, selfWrite = false;
  var currentN = 1;
  function offOf(n) { return n >= 3 ? OFF3 : (n === 2 ? OFF2 : 0); }
  function parsePrice(txt) {
    if (txt == null) return null;
    var t = String(txt).replace(/ /g, ' ').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
    var m = t.match(/\d[\d .,]*\d|\d/); if (!m) return null;
    var num = m[0], at = t.indexOf(num);
    var prefix = t.slice(0, at).replace(/\s+$/, ' '), suffix = t.slice(at + num.length).replace(/^\s+/, ' ');
    var dec = 0, decSep = ',', dm = num.match(/[.,](\d{2})$/);
    if (dm) { dec = 2; decSep = num.charAt(num.length - 3); }
    var digits = num.replace(/[^0-9]/g, ''); if (!digits) return null;
    var cents = parseInt(digits, 10); if (isNaN(cents)) return null;
    return { cents: cents, dec: dec, decSep: decSep, prefix: prefix, suffix: suffix };
  }
  function fmtWith(info, cents) {
    if (!info) return '';
    var s = String(Math.round(cents)), frac = '';
    if (info.dec > 0) { while (s.length <= info.dec) s = '0' + s; frac = s.slice(s.length - info.dec); s = s.slice(0, s.length - info.dec); }
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return info.prefix + s + (info.dec > 0 ? info.decSep + frac : '') + info.suffix;
  }
  function fmt(c) { return fmtWith(base, c); }
  /* 24/09 23h : calcul IDENTIQUE au panier Shopify (mesuré) : prix unitaire remisé arrondi
     aux 10 centimes, multiplié par la quantité. Avant : écart de 1 à 2 centimes avec le panier. */
  /* 25/09 05h05 (bug trouvé au test : fiche 123,40 € / panier 123,50 € sur une applique à 64,99 €) : Shopify calcule la remise
     PAR ARTICLE et l'arrondit au centime INFÉRIEUR (5 % de 64,99 = 3,2495 → 3,24), puis multiplie par la quantité.
     L'ancien calcul (prix unitaire arrondi aux 10 centimes) ne tombait juste que par hasard sur certains prix. */
  function totPack(n) { var off = offOf(n); if (!off) return base.cents * n; var r = base.cents * off; return (base.cents - (r - r % 100) / 100) * n; }
  /* 25/09 01h25 : prix du haut (prix, ancien prix barré, pastille « Économisez ») = total pour la quantité choisie */
  var ecoC = null, ecoB = null, cmpBase = 0, topSelf = false;
  function readCmp() {
    ecoC = document.querySelector('[id^="mzEcoCompare-"]'); ecoB = document.querySelector('[id^="mzEcoBadge-"]');
    var p = (ecoC && !ecoC.hidden) ? parsePrice(ecoC.textContent) : null;
    cmpBase = p ? p.cents : 0;
  }
  function topSync(n, promo) {
    if (!priceEl || !base) return;
    topSelf = true;
    var pt = fmt(n > 1 ? promo : base.cents);
    if (priceEl.textContent !== pt) priceEl.textContent = pt;
    var ref = cmpBase ? cmpBase * n : (promo < base.cents * n ? base.cents * n : 0);
    if (ecoC) { if (ref > promo) { var ct = fmt(ref); if (ecoC.textContent !== ct) ecoC.textContent = ct; ecoC.hidden = false; } else { ecoC.hidden = true; } }
    if (ecoB) {
      if (ref > promo) {
        var tpl = ecoB.getAttribute('data-tpl') || 'Save [montant]';
        var bt = tpl.replace('[montant]', fmt(ref - promo).replace(/,00(\s?€)/, '$1'));
        if (ecoB.textContent.trim() !== bt) ecoB.textContent = bt;
        ecoB.hidden = false;
      } else { ecoB.hidden = true; }
    }
    setTimeout(function () { topSelf = false; }, 0);
  }
  function render() {
    if (!base) return;
    var n = currentN, off = offOf(n), full = base.cents * n, promo = totPack(n);
    step.querySelector('[data-pk-n]').textContent = String(n);
    step.querySelector('[data-pk-d="-1"]').disabled = n <= 1;
    step.querySelector('[data-pk-d="1"]').disabled = n >= MAXQ;
    var g = info.querySelector('[data-pk-g]');
    if (off > 0) { g.classList.add('is-on'); g.innerHTML = '<b>−' + off + ' %</b> applied to ' + n + ' items'; }
    else { g.classList.remove('is-on'); g.innerHTML = (OFF2 > 0 ? '<b>−' + OFF2 + ' %</b> from 2' : '') + (OFF3 > 0 ? ' · <b>−' + OFF3 + ' %</b> from 3' : ''); }
    info.querySelector('[data-pk-old]').textContent = off > 0 ? fmt(full) : '';
    info.querySelector('[data-pk-total]').textContent = fmt(promo);
    /* maquette R */
    var rt = info.querySelector('[data-pk-rt]'), rn = info.querySelector('[data-pk-rn]'), rf = info.querySelector('[data-pk-rf]');
    if (rt) {
      /* 25/09 03h30 (maquette V1) : titre fixe, l'économie en euros s'écrit sous la frise */
      var sv = info.querySelector('[data-pk-sv]');
      if (sv) {
        var pot2 = base.cents * 2 - totPack(2), save = full - promo;
        sv.textContent = n <= 1 ? (pot2 > 0 ? ('Add 1 more: you save ' + fmt(pot2) + '.') : '') : (n === 2 ? ('You save ' + fmt(save) + ' · 1 more for −' + OFF3 + ' %') : ('You save ' + fmt(save) + ', the best price.'));
      }
      rf.style.width = n >= 3 ? '100%' : (n === 2 ? '50%' : '0%');
      var sts = info.querySelectorAll('[data-pk-go]');
      for (var si = 0; si < sts.length; si++) { var sv = parseInt(sts[si].getAttribute('data-pk-go'), 10); sts[si].classList.toggle('is-on', n >= sv); sts[si].classList.toggle('is-cur', sv === n); }
      /* 25/09 20h : cartes 1 / 2 / 3 — total de chaque pack (calcul panier) + ancien prix barré */
      for (var ci = 0; ci < sts.length; ci++) {
        var cq = parseInt(sts[ci].getAttribute('data-pk-go'), 10), cpE = sts[ci].querySelector('[data-pk-cp]'), coE = sts[ci].querySelector('[data-pk-co]');
        if (!cpE) continue;
        /* 04/10 (Lancelot) : sur chaque carte, la remise TOTALE en % au lieu de « Vous économisez X € » :
           1 = remise de base du produit (prix barré), 2 et 3 = remise de base + remise pack, calculée sur le vrai prix barré × quantité. */
        var ct = totPack(cq), cf = (cmpBase > base.cents ? cmpBase : base.cents) * cq;
        if (cpE.textContent !== fmt(ct)) cpE.textContent = fmt(ct);
        if (coE) coE.textContent = ct < cf ? fmt(cf) : '';
        var csE = sts[ci].querySelector('[data-pk-cs]'); if (csE) { var pc = ct < cf ? Math.round((cf - ct) * 100 / cf) : 0; /* 07/10 (Lancelot) : « Économisez X € » à la place de « −25 % » */ var csT = pc > 0 ? '\u0053ave\u00a0' + Math.round((cf - ct) / 100).toLocaleString(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '\u00a0'; if (csE.textContent !== csT) csE.textContent = csT; csE.classList.toggle('almpk-pct', pc > 0); }
        sts[ci].setAttribute('aria-checked', cq === n ? 'true' : 'false');
      }
    }
    /* 07/10 21h05 : 3e carte « 3 et + » : sélectionnée dès 3, affiche le total pour la quantité choisie */
    var c3 = info.querySelector('[data-pk-plus]');
    if (c3) {
      var on3 = n >= 3, m3 = Math.max(n, 3);
      c3.classList.toggle('is-cur', on3); c3.setAttribute('aria-checked', on3 ? 'true' : 'false');
      var pn = c3.querySelector('[data-pk-pn]'); if (pn) pn.textContent = String(m3);
      var mb = c3.querySelector('[data-pk-pm="-1"]'), pb = c3.querySelector('[data-pk-pm="1"]');
      if (mb) mb.disabled = n <= 3; if (pb) pb.disabled = n >= MAXQ;
      if (n > 3) {
        var t3 = totPack(m3), f3 = (cmpBase > base.cents ? cmpBase : base.cents) * m3;
        var p3 = c3.querySelector('[data-pk-cp]'), o3 = c3.querySelector('[data-pk-co]'), s3 = c3.querySelector('[data-pk-cs]');
        if (p3) p3.textContent = fmt(t3);
        if (o3) o3.textContent = t3 < f3 ? fmt(f3) : '';
        if (s3) { s3.textContent = t3 < f3 ? '\u0053ave\u00a0' + Math.round((f3 - t3) / 100).toLocaleString(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '\u00a0'; s3.classList.toggle('almpk-pct', t3 < f3); }
      }
    }
    /* 25/09 01h25 (Lancelot) : pas de total dans le bouton ; c'est le PRIX DU HAUT qui passe au total */
    /* 25/09 20h : avec les cartes, le prix du haut reste le prix UNITAIRE (les totaux sont dans les cartes) */
    topSync(1, base.cents);
  }
  function watchSticky() {
    stickyEl = document.querySelector('.nty-sticky-price');
    if (!stickyEl || stObs) return;
    stickyInfo = parsePrice(stickyEl.textContent);
    stObs = new MutationObserver(function () { if (selfWrite) return; var ni = parsePrice(stickyEl.textContent); if (ni) stickyInfo = ni; syncSticky(); });
    stObs.observe(stickyEl, { childList: true, characterData: true, subtree: true });
  }
  function syncSticky() {
    if (!stickyEl) watchSticky();
    if (!stickyEl || !base || !stickyInfo) return;
    var full = base.cents * currentN, promo = totPack(currentN);
    var txt = fmtWith(stickyInfo, promo);
    if (stickyEl.textContent === txt) return;
    selfWrite = true; stickyEl.textContent = txt; setTimeout(function () { selfWrite = false; }, 0);
  }
  function setQty(n) {
    if (!qtyEl) qtyEl = document.querySelector('[id^="mzQtyInput"]');
    if (!qtyEl) return;
    qtyEl.value = String(n);
    try { qtyEl.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
    try { qtyEl.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    var st = document.querySelector('[id^="mzStickyQtyInput"]'); if (st) st.value = String(n);
  }
  step.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pk-d]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    currentN = Math.max(1, Math.min(MAXQ, currentN + parseInt(b.getAttribute('data-pk-d'), 10)));
    setQty(currentN); render(); syncSticky();
  });
  /* 07/10 21h05 : + / − de la carte « 3 et + » (3 à 23) ; un appui ailleurs sur la carte = 3 (géré plus bas) */
  info.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pk-pm]') : null;
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.disabled) return;
    var d = parseInt(b.getAttribute('data-pk-pm'), 10);
    currentN = Math.max(3, Math.min(MAXQ, Math.max(currentN, 3) + d));
    setQty(currentN); render(); syncSticky();
  });
  info.addEventListener('keydown', function (e) { var c = e.target && e.target.matches && e.target.matches('[data-pk-plus]'); if (c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); currentN = 3; setQty(3); render(); syncSticky(); } });
  /* maquette R : un clic sur 1 / 2 / 3 choisit directement la quantité */
  info.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pk-go]') : null;
    if (!b) return;
    e.preventDefault();
    currentN = Math.max(1, Math.min(MAXQ, parseInt(b.getAttribute('data-pk-go'), 10) || 1));
    setQty(currentN); render(); syncSticky();
  });
  /* 24/09 21h15 (Lancelot) : sur MOBILE le compteur passe AU-DESSUS du bouton, sur la même ligne que l'économie et le prix ;
     sur PC il reste collé à gauche du bouton (ligne économie + prix au-dessus). */
  var mline = null;
  function isMob() { return !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches); }
  function place() {
    row = document.querySelector('[class*="mz-atc-row-"]');
    if (!row || !row.parentNode) return false;
    /* 24/09 23h55 (Lancelot) : sur mobile, MÊME disposition que sur PC — ligne « −5 % dès 2 … prix » au-dessus,
       sélecteur collé à gauche du bouton « Ajouter au panier ». (Ancienne ligne mobile gardée derrière false.) */
    if (false) {
      if (!mline) { mline = document.createElement('div'); mline.className = 'almpk-mline'; }
      if (step.parentNode !== mline) mline.appendChild(step);
      if (info.parentNode !== mline) mline.appendChild(info);
      if (row.previousElementSibling !== mline) row.parentNode.insertBefore(mline, row);
    } else {
      var atc = row.querySelector('[class*="mz-atc-btn-"]');
      if (step.parentNode !== row) row.insertBefore(step, atc || row.firstChild);
      /* 25/09 01h20 (Lancelot) : la ligne « Livré du … au … / Livraison offerte » se pose JUSTE AU-DESSUS du bouton
         d'achat, sous la ligne « −5 % dès 2 … ». Ordre : info, livraison, sélecteur + bouton. */
      var liv = document.querySelector('.alm-liv');
      if (liv) {
        if (row.previousElementSibling !== liv) row.parentNode.insertBefore(liv, row);
        if (liv.previousElementSibling !== info) row.parentNode.insertBefore(info, liv);
      } else if (row.previousElementSibling !== info) row.parentNode.insertBefore(info, row);
      if (mline && mline.parentNode) mline.parentNode.removeChild(mline);
    }
    /* 24/09 21h20 : la mention « Aucune ampoule à acheter » (script ampoule, qui se pose juste AVANT l'élément .almpk__grid)
       s'était retrouvée en bas de la fiche avec le nouveau sélecteur : on lui redonne sa cible = le 1er élément du sélecteur. */
    /* 24/09 21h45 (Lancelot) : LED intégrée → « Aucune ampoule à acheter » AU-DESSUS de la ligne d'avis ;
       modèles à douille (ampoule offerte / lot) → reste juste au-dessus du sélecteur. */
    var ampE = document.getElementById('almAmpoule');
    /* 21h40 (Lancelot) : LED intégrée → AU-DESSUS des avis ; ampoules offertes → EN DESSOUS des avis, comme avant (au-dessus du sélecteur). */
    var led = !!(ampE && ampE.getAttribute('data-cas') === 'led');
    /* 22h35 (Lancelot, décision finale) : « Ampoules incluses » AUSSI au-dessus des avis → tous les blocs ampoule au-dessus. */
    var avisB = document.querySelector('[class*="mz-product-info-col"] > [class^="mz-alm-avis-"]');
    /* 25/09 00h12 (Lancelot, avis remontés en haut) : la mention ampoules se pose juste AU-DESSUS de la ligne « −5 % dès 2 … prix ». */
    var first = info;
    [info, mline].forEach(function (x) { if (x && x !== first) x.classList.remove('almpk__grid'); });
    if (first) first.classList.add('almpk__grid');
    /* 22h50 : peu d'espace au-dessus du bloc ampoules = on réduit le bas de l'élément VISIBLE juste avant (variantes ou points forts). */
    setTimeout(function () {
      ['almAmpoule', 'almLot'].forEach(function (id) {
        var e = document.getElementById(id); if (!e) return;
        var p = e.previousElementSibling;
        while (p && (p.offsetHeight === 0 || (p.id === 'almAmpoule' || p.id === 'almLot'))) p = p.previousElementSibling;
        if (p) { p.style.setProperty('padding-bottom', '6px', 'important'); p.style.setProperty('margin-bottom', '0', 'important'); }
      });
    }, 0);
    /* 25/09 00h05 : si le bloc déplaçable « 💡 Bloc ampoules » est présent dans l'éditeur, la mention va DEDANS. */
    var slotA = document.querySelector('.alm-amp-slot');
    if (slotA) { ['almAmpoule', 'almLot'].forEach(function (id) { var e = document.getElementById(id); if (e && e.parentNode !== slotA) slotA.appendChild(e); }); }
    else ['almAmpoule', 'almLot'].forEach(function (id) { var e = document.getElementById(id); if (e && first && first.parentNode && e.nextElementSibling !== first && e !== first.previousElementSibling) first.parentNode.insertBefore(e, first); });
    box = row.parentNode;
    return true;
  }
  function placed(r) { var lv = document.querySelector('.alm-liv'); return step.parentNode === r && (lv ? (r.previousElementSibling === lv && lv.previousElementSibling === info) : r.previousElementSibling === info); }
  var lastMob = isMob();
  window.addEventListener('resize', function () { var m = isMob(); if (m !== lastMob) { lastMob = m; place(); } });
  function watchPrice() {
    if (!priceEl || prObs) return;
    prObs = new MutationObserver(function () { if (topSelf) return; var nb = parsePrice(priceEl.textContent); if (nb) { base = nb; readCmp(); render(); syncSticky(); } });
    prObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }
  function watchBox() {
    if (!box || boxObs) return;
    boxObs = new MutationObserver(function () { var r = document.querySelector('[class*="mz-atc-row-"]'); if (!r) return; if (!placed(r)) place(); });
    boxObs.observe(box, { childList: true, subtree: false });
  }
  function init() {
    qtyEl = document.querySelector('[id^="mzQtyInput"]');
    priceEl = document.querySelector('[id^="mzEcoPrice"]') || document.querySelector('[id^="mzPrice"]');
    if (!priceEl) return false;
    base = parsePrice(priceEl.textContent);
    if (!base) return false;
    if (!place()) return false;
    readCmp(); render(); watchPrice(); watchBox(); watchSticky(); syncSticky();
    return true;
  }
  if (!init()) {
    var tries = 0;
    var iv = setInterval(function () { tries++; if (init() || tries > 100) clearInterval(iv); }, 100);
    var boot = new MutationObserver(function () { if (init()) { boot.disconnect(); clearInterval(iv); } });
    boot.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { boot.disconnect(); } catch (e) {} }, 30000);
  }
})();

  })();
})(document.currentScript);
